<!-- 能耗管理-电表管理 -->
<template>
  
      <!--主内容区-->
      <!-- <div class="mainBodyContent"> -->
        <div class="CAmmeterManage">
          
          <div class="ammetRight">
            <div class="right_device">
              <div class="totalEMeterInfo">
                <div class="flexCont">
                  <div class="item">
                    <el-row :gutter="15">
                      <el-col :span="8"> 
                        <div class="totalUse">
                          <h2>本月用电量</h2>
                          <p><span class="num">{{totalInfo.thisMonthNum}}</span><em> KWH</em></p>
                        </div>
                      </el-col>
                      <el-col :span="8"> 
                        <div class="totalUse">
                          <h2>上月用电量</h2>
                          <p><span class="num1">{{totalInfo.lastMonthNum}}</span><em> KWH</em></p>
                        </div>
                      </el-col>
                      <el-col :span="8">
                        <!--电表数量统计-->
                        <TotalEMeterNum></TotalEMeterNum>
                      </el-col>
                    </el-row>
                    <div class="useTrend">
                      <!--用电趋势标题-->
                      <div class="UseTrendTitle">
                        <UseTrendTitle></UseTrendTitle>
                      </div>
                      <!--用电趋势列表-->
                      <div class="UseTrendList">
                        <UseTrendList></UseTrendList>
                      </div>
                    </div>
                  </div>
                  <div class="itemLast" ref="itemLast">
                    <!--分组信息-->
                    <GroupInfo></GroupInfo>
                  </div>
                </div>
              </div>
              <!--预警设置-->
              <!-- <div class="AlarmSetting">
                <AlarmSetting></AlarmSetting>
              </div> -->
              <!--预警显示-->
              <div class="AlarmShow">
                <AlarmShow></AlarmShow>
              </div>
              <!--用电排名标题-->
              <!-- <div class="TopTitle">
                <TopTitle></TopTitle>
              </div> -->
              <!--用电排名列表显示-->
              <!-- <div class="TopEMeterList">
                <TopEMeterList></TopEMeterList>
              </div> -->
              
              
              <!--抄表记录标题-->
              <div class="ReadWatchTitle">
                <ReadWatchTitle></ReadWatchTitle>
              </div>
              <!--抄表记录列表-->
              <div class="ReadWatchList">
                <ReadWatchList></ReadWatchList>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
 
</template>

<script>
  import { showToast } from '../../../../static/js/utility/utility'
  import * as powerControl from "../../../../static/js/powerControl.js"
  import * as yuLei from "../../../../static/js/yuLei.js"
  import { deviceApi } from "../../../../static/js/api.js"
  import TotalEMeterNum from './BuildingInfo/TotalEMeterNum.vue' 
  import GroupInfo from './BuildingInfo/GroupInfo.vue' 
  import AlarmSetting from './BuildingInfo/AlarmSetting.vue' 
  import AlarmShow from './BuildingInfo/AlarmShow.vue'  
  import UseTrendTitle from './BuildingInfo/UseTrendTitle.vue' 
  import UseTrendList from './BuildingInfo/UseTrendList.vue' 
  import ReadWatchTitle from './BuildingInfo/ReadWatchTitle.vue' 
  import ReadWatchList from './BuildingInfo/ReadWatchList.vue'
  


  export default {
    name: 'CAmmeterManage',
    components: {
      // TotalUse,
      TotalEMeterNum,
      GroupInfo,
      AlarmSetting,
      AlarmShow,
      // TopTitle,
      // TopEMeterList,
      UseTrendTitle,
      UseTrendList,
      ReadWatchTitle,
      ReadWatchList,
    },
    data() {
      return {
        totalInfo:{
          lastMonthNum:'',
          thisMonthNum:''
        },//上月和本月用电
        itemH:0,
      }
    },
    mounted(){
      var itemH =this.$refs.itemLast.offsetHeight;
      this.$store.state.itemH = itemH
    },
    created: async function () {
      this.getWattMetter()
    },
    methods: {
      async getWattMetter(){
        let that = this;
        const res = await deviceApi.getWattMetter()
        if(res.meta.code == '200'){
          that.totalInfo ={
            lastMonthNum:res.data.lastMonthNum,
            thisMonthNum:res.data.thisMonthNum,
          }
          // that.deviceNum={
          //   onlineNum:res.data.onlineNum,
          //   offlineNum:res.data.offlineNum,
          // }
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CAmmeterManage{
  display: flex;
  .ammetRight{
    flex-grow: 1;
    .flexCont{
      display: flex;
      .item{
        flex-grow: 1;
        margin-right: 15px;
        .useTrend{
          margin-top: 15px;
          background-color: #fff;
          box-shadow: 0 6px 7px 5px rgba(7,0,2,.06);
        }
        .totalUse{
          height: 148px;
          background: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 90px;
          box-sizing: border-box;
          box-shadow: 0 6px 7px 5px rgba(7,0,2,.06);
          h2{
            font-size: 16px;
            color: #666;
            font-weight: normal;
          }
          em{
            font-size: 18px;
            color: #a7b2c5;
          }
          .num{
            font-size: 36px;
            color: #3c4a79;
          }
          .num1{
            font-size: 24px;
            color: #333;
          }
        }
      }
      .itemLast{
        width: 234px;
        flex-shrink: 0;
        background: #fff;
        box-shadow: 0 6px 7px 5px rgba(7,0,2,.06);
      }
    }
  }
  .right_meter{
    .titleText {
      margin-top: 30px;
      margin-left: 30px;
      color:white;
    }
    .clearfix::after {
      content: ''; 
      display: block; 
      clear:both;
    }
  }
  .right_device{
    .titleText {
      margin-top: 30px;
      margin-left: 30px;
      color:white;
    }

    .TopTitle {
      width:95.6%;
      height:60px;
      margin-top: 20px;
      margin-left: 40px;
    }
    .TopEMeterList {
      width:95.6%;
      height:350px;
      margin-top: 20px;
      margin-left: 40px;
    }
    .clearfix::after {
      content: ''; 
      display: block; 
      clear:both;
    }
  }
  
  
}

</style>



// WEBPACK FOOTER //
// src/components/Page/CEnergyManage/CAmmeterManage.vue